import * as v from "valibot";

export const overviewSearchParams = v.object({
  view: v.optional(v.string()),
  createView: v.optional(v.boolean()),
  createTender: v.optional(v.boolean()),
  page: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  q: v.optional(v.string()),
});
